import { Button, HStack } from '@chakra-ui/react';
import { useAuthModal } from '@/hooks';
import { siteNavAccountButtonProps } from './siteNavLayout';

/** Desktop log in / sign up (hidden when nav is compact; auth lives in the drawer). */
export function SiteNavAuthButtons(props: { visible: boolean }) {
  const { openLoginModal, openRegisterModal } = useAuthModal();

  if (!props.visible) return null;

  return (
    <HStack spacing={2}>
      <Button {...siteNavAccountButtonProps} variant='ghost' onClick={openLoginModal}>
        Log in
      </Button>
      <Button {...siteNavAccountButtonProps} variant='outline' onClick={openRegisterModal}>
        Sign up
      </Button>
    </HStack>
  );
}
